/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React, { Component } from "react";
import Label from "../../components/label";
import SearchInput from "../../components/searchInput";
import OpenAppointmentList from "../../containers/OpenAppointmentList";
import MakeAPICall from "../../apiCalls/common";

class OpenAppointmentPage extends Component {
  constructor() {
    super();
    this.state = {
      openAppointmentSearch: "",
      apiCall: null,
    };
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  };

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  render() {
    return (
      <div className="row rounded p-3 open-appointment-page">
        {/* Top Filters */}
        <div className="col-sm-5 p-3">
          <Label title="Open Appointments" className="big" />
        </div>
        <div className="col-sm-4 offset-sm-3 p-3 text-right pt-3">
          <SearchInput
            id="postcode"
            name="postcode"
            onChange={e =>
              this.setState({ openAppointmentSearch: e.target.value })
            }
            value={this.state.openAppointmentSearch}
            className="w-100 font-14"
            placeholder="Search"
          />
        </div>
        <div className="col-sm-12 border-bottom"></div>

        <div className="col-sm-12 mt-5">
          <OpenAppointmentList  makeAPICall={this.componentAPICall}/>
        </div>
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
      </div>
    );
  }
}

export default OpenAppointmentPage;
